import type { SVGProps } from 'react'
import * as React from 'react'

const SvgSparkleCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.5"
      y="0.5"
      width="31"
      height="31"
      rx="15.5"
      fill="url(#paint0_linear_3182_15256)"
    />
    <rect
      x="0.5"
      y="0.5"
      width="31"
      height="31"
      rx="15.5"
      stroke="url(#paint1_linear_3182_15256)"
    />
    <path
      d="M20.3488 16.0662L17.1232 14.8787L15.9357 11.6506C15.8653 11.4596 15.7381 11.2947 15.5711 11.1782C15.4042 11.0618 15.2055 10.9993 15.0019 10.9993C14.7983 10.9993 14.5997 11.0618 14.4327 11.1782C14.2657 11.2947 14.1385 11.4596 14.0682 11.6506L12.8794 14.875L9.65129 16.0625C9.46025 16.1328 9.29537 16.2601 9.17891 16.427C9.06244 16.594 9 16.7927 9 16.9963C9 17.1998 9.06244 17.3985 9.17891 17.5655C9.29537 17.7324 9.46025 17.8597 9.65129 17.93L12.875 19.125L14.0625 22.3512C14.1329 22.5423 14.2601 22.7072 14.4271 22.8236C14.594 22.9401 14.7927 23.0025 14.9963 23.0025C15.1999 23.0025 15.3985 22.9401 15.5655 22.8236C15.7325 22.7072 15.8597 22.5423 15.93 22.3512L17.1175 19.1256L20.3457 17.9381C20.5367 17.8678 20.7016 17.7406 20.8181 17.5736C20.9345 17.4066 20.997 17.208 20.997 17.0044C20.997 16.8008 20.9345 16.6021 20.8181 16.4352C20.7016 16.2682 20.5367 16.1409 20.3457 16.0706L20.3488 16.0662ZM16.7744 18.1875C16.6393 18.2371 16.5166 18.3155 16.4148 18.4173C16.313 18.519 16.2346 18.6418 16.185 18.7769L14.9975 21.9931L13.8125 18.7744C13.7629 18.64 13.6848 18.5179 13.5834 18.4166C13.4821 18.3153 13.3601 18.2371 13.2257 18.1875L10.0094 17L13.2257 15.8125C13.3601 15.7629 13.4821 15.6847 13.5834 15.5834C13.6848 15.4821 13.7629 15.36 13.8125 15.2256L15 12.0094L16.1875 15.2256C16.2371 15.3607 16.3155 15.4834 16.4173 15.5852C16.5191 15.687 16.6418 15.7654 16.7769 15.815L19.9932 17.0025L16.7744 18.1875ZM17 10.5C17 10.3674 17.0527 10.2402 17.1465 10.1464C17.2403 10.0527 17.3674 10 17.5 10H18.5V9C18.5 8.86739 18.5527 8.74021 18.6465 8.64645C18.7403 8.55268 18.8674 8.5 19 8.5C19.1326 8.5 19.2598 8.55268 19.3536 8.64645C19.4474 8.74021 19.5 8.86739 19.5 9V10H20.5C20.6326 10 20.7598 10.0527 20.8536 10.1464C20.9474 10.2402 21 10.3674 21 10.5C21 10.6326 20.9474 10.7598 20.8536 10.8536C20.7598 10.9473 20.6326 11 20.5 11H19.5V12C19.5 12.1326 19.4474 12.2598 19.3536 12.3536C19.2598 12.4473 19.1326 12.5 19 12.5C18.8674 12.5 18.7403 12.4473 18.6465 12.3536C18.5527 12.2598 18.5 12.1326 18.5 12V11H17.5C17.3674 11 17.2403 10.9473 17.1465 10.8536C17.0527 10.7598 17 10.6326 17 10.5ZM23.5 13.5C23.5 13.6326 23.4474 13.7598 23.3536 13.8536C23.2598 13.9473 23.1326 14 23 14H22.5V14.5C22.5 14.6326 22.4474 14.7598 22.3536 14.8536C22.2598 14.9473 22.1326 15 22 15C21.8674 15 21.7403 14.9473 21.6465 14.8536C21.5527 14.7598 21.5 14.6326 21.5 14.5V14H21C20.8674 14 20.7403 13.9473 20.6465 13.8536C20.5527 13.7598 20.5 13.6326 20.5 13.5C20.5 13.3674 20.5527 13.2402 20.6465 13.1464C20.7403 13.0527 20.8674 13 21 13H21.5V12.5C21.5 12.3674 21.5527 12.2402 21.6465 12.1464C21.7403 12.0527 21.8674 12 22 12C22.1326 12 22.2598 12.0527 22.3536 12.1464C22.4474 12.2402 22.5 12.3674 22.5 12.5V13H23C23.1326 13 23.2598 13.0527 23.3536 13.1464C23.4474 13.2402 23.5 13.3674 23.5 13.5Z"
      fill="url(#paint2_linear_3182_15256)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3182_15256"
        x1="16"
        y1="0"
        x2="16"
        y2="38"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F0EFFE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3182_15256"
        x1="16"
        y1="0"
        x2="16"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F4F3FF" />
        <stop offset="1" stopColor="#DBD8FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3182_15256"
        x1="24.1145"
        y1="7.88549"
        x2="12.3158"
        y2="19.6821"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5E56F9" />
        <stop offset="1" stopColor="#BB56F9" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgSparkleCircle
